import { Component, HostBinding, Input } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'simple-spinner',
  templateUrl: 'spinner.component.html',
  styleUrls: ['spinner.component.scss'],
})
export class SpinnerComponent {

  @HostBinding('class.show')
  @Input() isShown: boolean = false;

  show(show: boolean) {
    this.isShown = show;
  }

  toggle() {
    this.isShown = !this.isShown;
  }
}
